import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function branch() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`branch/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`branch/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('branch/create', data);
    }

    function update(data) {
        return axiosInstance.patch('branch/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`branch/delete`, {
            data: {
                id: id
            }
        });
    }
}
